import { useState, useCallback, memo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby-plugin-react-i18next';
import {
	Accordion,
	AccordionItem,
	AccordionItemHeading,
	AccordionItemButton,
	AccordionItemPanel,
} from 'react-accessible-accordion';
import { renderRichText } from 'gatsby-source-contentful/rich-text';

const _FAQsSection = ({ items, title, showLink, className }) => {
	const [activeIndex, setActiveIndex] = useState(null);

	const handleAccordionChange = useCallback(
		(index) => () => {
			setActiveIndex(index === activeIndex ? null : index);
		},
		[setActiveIndex]
	);

	return (
		<section className={`faq__wrap ${className}`}>
			<div className="faq__container">
				<h2 className="faq__container-title">{title}</h2>
				<Accordion
					className="faq__container-accordion accordion"
					allowZeroExpanded={true}
				>
					{items.map((faq, index) => {
						const { question, answer, id } = faq;
						return (
							<AccordionItem
								className="faq__container-accordion-item accordion__item"
								key={id}
								uuid={id}
							>
								<AccordionItemHeading
									className="faq__container-accordion-header"
									onClick={handleAccordionChange(index)}
								>
									<AccordionItemButton
										aria-expanded={
											activeIndex === index ? true : false
										}
										className="accordion__button typography typography--black btn btn--transparent"
									>
										{question}
									</AccordionItemButton>
								</AccordionItemHeading>

								<AccordionItemPanel className={'accordion__panel'}>
									{answer !== null && renderRichText(answer)}
								</AccordionItemPanel>
							</AccordionItem>
						);
					})}
				</Accordion>
				{showLink && (
					<div className="faq__container-link-container">
						<Link className="faq__container-link" to="/faqs/">
							View all FAQs
						</Link>
					</div>
				)}
			</div>
		</section>
	);
};

_FAQsSection.propTypes = {
	items: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string,
			copy: PropTypes.string,
		})
	).isRequired,
	title: PropTypes.string,
	showLink: PropTypes.bool,
	className: PropTypes.string,
};

_FAQsSection.defaultProps = {
	items: [],
	className: '',
};

const FAQsSection = memo(_FAQsSection);

export default FAQsSection;
